// generated by the plop

import { DebtExpectBackend, DebtModel } from 'shared';
import { UUID } from 'symbols';


export class GetDebtById {
  static type = '[debtManage] GetDebtById';

  constructor(public id: UUID) {
  }
}

export class GetDebtByIdSuccess {
  static type = '[debtManage] GetDebtByIdSuccess';

  constructor(public debt: DebtModel) {
  }
}

export class GetDebtByIdFail {
  static type = '[debtManage] GetDebtByIdFail';

  constructor(public error: unknown) {
  }
}

export class SetCurrentDebtId {
  static type = '[debtManage] SetCurrentDebtId';

  constructor(public id: UUID) {
  }
}


export class UpdateLocalDebt {
  static type = '[debtManage] UpdateLocalDebt';

  constructor(public debt: DebtModel) {
  }
}

export class DeleteLocalDebt {
  static type = '[debtManage] DeleteLocalDebt';

  constructor(public id: UUID) {
  }
}

export class UpdateDebt {
  static type = '[debtManage] UpdateDebt';

  constructor(public id: UUID, public debt: DebtExpectBackend, public force: boolean) {
  }
}

export class UpdateDebtSuccess {
  static type = '[debtManage] UpdateDebtSuccess';

  constructor(public debt: DebtModel) {
  }
}

export class UpdateDebtFail {
  static type = '[debtManage] UpdateDebtFail';

  constructor(public error: unknown) {
  }
}
